import IBean from './IBean'

export default class WFSBean extends IBean {
    constructor({
        url,
        layerName,
        geometryName = 'GEOMETRY',
        maxFeatures = null
    }) {
        super()
        this.url = url
        this.layerName = layerName
        this.geometryName = geometryName
        this.maxFeatures = maxFeatures
    }
}
